import { UrlConfig } from 'config';
import { CompositeIndexModel, CompositeIndexType, RawCompositeIndex } from 'models/CompositeIndex/CompositeIndex';
import { AjaxService } from 'services';

export class CompositeIndexApiClient {
  public static async getCompositeIndexByType(type: CompositeIndexType): Promise<CompositeIndexModel> {
    const response = await AjaxService.getData(`${UrlConfig.COMPOSITE_INDEX.BASE}/${type}`);
    return new CompositeIndexModel(response.data as RawCompositeIndex);
  }

  public static async refreshCompositeIndex(type: CompositeIndexType): Promise<void> {
    await AjaxService.postData(UrlConfig.COMPOSITE_INDEX.INDEX_REFRESH, { type });
  }

  public static async regenerateCompositeIndex(name: string, type: CompositeIndexType): Promise<void> {
    await AjaxService.postData(UrlConfig.COMPOSITE_INDEX.INDEX_REGENERATE, { name, type });
  }
}
